import React, { useState, useEffect, useRef } from 'react';
import { t } from '../../i18n/i18n';
import './DashboardSlider.scss';

const SLIDES = [
  {
    id: 1,
    // Two lines, broken where the design breaks them.
    title: ['Optimize Trades', 'with Backtesting'],
    copy: 'Test and optimize strategies with historical data to reduce risk and trade with confidence.',
    bgStyle: { '--insights-bg': 'url(/icons/insights-bg.svg)' },
    bgClass: 'insights__bg-image',
  },
  {
    id: 2,
    title: ['Advanced Diploma', 'in Financial Trading'],
    copy: 'Trading is easy to start. Hard to master. Are you ready to invest six weeks in yourself?',
    bgStyle: { background: 'linear-gradient(135deg, #e0532b 0%, #a81c07 100%)' },
    bgClass: 'insights__bg-orange',
  },
  {
    id: 3,
    title: ['Where Discipline', 'Meets Performance'],
    copy: 'Advanced charts, instant execution, and performance tracking designed to expose your edge.',
    bgStyle: { background: 'linear-gradient(135deg, #161616 0%, #0d0d0d 100%)' },
    bgClass: 'insights__bg-dark',
  },
];

const icon = (name) => ({ '--icon': `url(/icons/${name}.svg)` });

export default function DashboardSlider() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const autoplayTimerRef = useRef(null);

  const startAutoplay = () => {
    stopAutoplay();
    autoplayTimerRef.current = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % SLIDES.length);
    }, 5000);
  };

  const stopAutoplay = () => {
    if (autoplayTimerRef.current) {
      clearInterval(autoplayTimerRef.current);
    }
  };

  useEffect(() => {
    startAutoplay();
    return () => stopAutoplay();
  }, []);

  const handleDotClick = (index) => {
    setCurrentSlide(index);
    startAutoplay(); // Reset autoplay timer on manual click
  };

  return (
    <aside className="insights dashboard-slider">
      {SLIDES.map((slide, index) => {
        const isActive = index === currentSlide;
        return (
          <div
            key={slide.id}
            className={`dashboard-slider__slide ${isActive ? 'is-active' : ''}`}
            style={{
              position: index === 0 ? 'relative' : 'absolute',
              opacity: isActive ? 1 : 0,
            }}
          >
            {/* Slide Background Overlay */}
            <span
              className={`insights__bg ${slide.bgClass}`}
              style={slide.bgStyle}
            />

            {/* Slide Header */}
            <div className="insights__top">
              <span className="icon insights__mark" style={icon('brand-mark')} />
              <span className="insights__pill">{t('Latest Insights')}</span>
            </div>

            {/* Slide Content */}
            <div className="insights__body">
              <h2 className="insights__title">
                {t(slide.title[0])}
                <br />
                {t(slide.title[1])}
              </h2>
              <p className="insights__copy">{t(slide.copy)}</p>
              {/* No links (TI review N99): two of them went nowhere — /myalpha
                  is a 404 and "View from Futures" reloaded the dashboard — and
                  the review asked for all of them to go. */}
            </div>
          </div>
        );
      })}

      {/* Slide Navigation Bars */}
      <div className="insights__dots">
        {SLIDES.map((_, index) => (
          <button
            key={index}
            type="button"
            className={`insights__dot ${index === currentSlide ? 'is-active' : ''}`}
            onClick={() => handleDotClick(index)}
            aria-label={t('Go to slide {{n}}', { n: index + 1 })}
          />
        ))}
      </div>
    </aside>
  );
}
